var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVerve(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 29,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#verve_svg__clip0_8701_9949)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.73 14.755c0 7.745-6.28 14.024-14.025 14.024C6.959 28.78.68 22.5.68 14.755.68 7.009 6.959.73 14.705.73S28.73 7.01 28.73 14.755z",
    fill: "#ED342B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.707 20.762C11.57 13.652 9.27 7.01 9.27 7.01H4.46s2.928 8.526 8.365 19.188h3.765C22.026 15.535 24.953 7.01 24.953 7.01h-4.809s-2.3 6.643-5.437 13.753z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.105 14.023c-2.719 0-2.928 2.928-2.928 2.928h5.854s-.208-2.928-2.926-2.928zm6.481 5.855h-9.409s.209 3.137 4.391 3.137c2.091 0 4.182-.628 4.182-.628l.418 3.345s-2.09.837-5.018.837c-4.182 0-7.946-2.09-7.946-7.945 0-4.6 2.928-7.528 7.11-7.528 6.273 0 6.69 6.273 6.273 8.782zm-31.994-4.94l.647-3.453s-5-1.517-9.063 1.294v13.81h4.316v-11.22c1.726-1.295 4.1-.432 4.1-.432zm-17.988-.915c-2.718 0-2.927 2.928-2.927 2.928h5.854s-.209-2.928-2.927-2.928zm6.482 5.855h-9.41s.21 3.137 4.391 3.137c2.09 0 4.182-.628 4.182-.628l.418 3.345s-2.09.837-5.018.837c-4.182 0-7.946-2.09-7.946-7.945 0-4.6 2.928-7.528 7.11-7.528 6.273 0 6.69 6.273 6.273 8.782zm22.037 1.433c-2.191-5.26-3.286-10.213-3.286-10.213l-4.382.001s2.19 8.459 5.916 15.468h3.504C65.6 19.557 67.791 11.1 67.791 11.1H63.41s-1.095 4.952-3.286 10.211z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "verve_svg__clip0_8701_9949"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.465 .555)",
    d: "M0 0h81.438v28.38H0z"
  })))));
}

export default SvgVerve;